angular.module('ui-ng-animation', []);
// module.exports = 'ui-ng-animation';



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-animation/src/main.js